import { memo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
});

export const NoCoordinatesLocationContent = memo(
  ({ locationCode, name, postcode }) => {
    const styles = useStyles();
    return (
      <View className={styles.container}>
        <View>
          {`Location ${locationCode} - ${name} has no specified position on the map.`}
        </View>
        {postcode ? (
          <View>
            {`Location could be drawn on the map if postcode ${postcode} position will be defined in map edit mode.`}
          </View>
        ) : null}
      </View>
    );
  }
);
